/**
 * FASE 20.2 — Families Query Adapter
 */

import { supabase }             from "../../supabase";
import { applyPermissionScope } from "../permissionFilters";

const FAMILY_FIELDS = "id, name, status, last_visit_date, member_count, church_id";

/**
 * Overview for a specific family by entity ID.
 * @param {string} entity_id
 * @returns {Promise<Object|null>}
 */
export async function getFamilyOverview(entity_id) {
  if (!entity_id) return null;
  const { data, error } = await supabase
    .from("families")
    .select(FAMILY_FIELDS)
    .eq("id", entity_id)
    .limit(1)
    .single();

  if (error) throw error;
  return data ?? null;
}

/**
 * Families that have never been visited or have no visit in 60+ days.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @returns {Promise<Object[]>}
 */
export async function getFamiliesNeedingFollowup(scope) {
  const cutoff = new Date(Date.now() - 60 * 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);

  // Families whose last visit date is older than cutoff OR null
  let query = supabase
    .from("families")
    .select("id, name, status, last_visit_date, member_count")
    .or(`last_visit_date.is.null,last_visit_date.lt.${cutoff}`)
    .eq("status", "activa")
    .order("last_visit_date", { ascending: true, nullsFirst: true })
    .limit(20);

  query = applyPermissionScope(query, scope);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

/**
 * Church activity summary — families with recent activity.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @returns {Promise<Object[]>}
 */
export async function getChurchFamilySummary(scope) {
  let query = supabase
    .from("families")
    .select("id, name, status, last_visit_date, member_count")
    .eq("status", "activa")
    .order("last_visit_date", { ascending: false, nullsFirst: false })
    .limit(10);

  query = applyPermissionScope(query, scope);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}
